import { render, staticRenderFns } from "./PollEditorMatrix.vue?vue&type=template&id=c413293a&scoped=true"
import script from "./PollEditorMatrix.vue?vue&type=script&lang=js"
export * from "./PollEditorMatrix.vue?vue&type=script&lang=js"
import style0 from "./PollEditorMatrix.vue?vue&type=style&index=0&id=c413293a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c413293a",
  null
  
)

export default component.exports